module.exports = __webpack_public_path__ + "img/leaf-sample-horizontal.66430aa9.jpg";